import { render, staticRenderFns } from "./update-password-dialog.vue?vue&type=template&id=bedcb9d4&scoped=true"
import script from "./update-password-dialog.vue?vue&type=script&lang=js"
export * from "./update-password-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedcb9d4",
  null
  
)

export default component.exports